export default "__VITE_ASSET__BHMmQQFA__"